import { MenuLink } from '@althera/website/layout/types';

export const links: MenuLink[] = [
  { id: 'home', to: '/', label: 'Home' },
  {
    id: 'about-us',
    label: 'About us',
    to: '/about-us',
    subLinks: [
      { to: 'key-facts', label: 'Key Facts' },
      { to: 'facilities', label: 'Facilities' }
    ]
  },
  {
    id: 'culture',
    label: 'Culture',
    to: '/culture',
    subLinks: [
      { to: 'our-mission', label: 'Our Mission' },
      { to: 'althera-values', label: 'Althera Values' },
      { to: 'our-sustainability-commitment', label: 'Our Sustainability Commitment' }
    ]
  },
  {
    id: 'team',
    label: 'Team',
    to: '/team',
    subLinks: [
      { to: 'global-management-team', label: 'Our People' },
      { to: 'leadership-team', label: 'Leadership Team' },
      { to: 'clinical-and-regulatory-expertise', label: 'Clinical and Regulatory Expertise' },
      { to: 'our-supply-chain-excellence', label: 'Our Supply Chain Excellence' }
    ]
  },
  { id: 'products', to: '/products', label: 'Products' },
  { id: 'careers', to: '/careers', label: 'Careers' },
  { id: 'contact-us', to: '/contact-us', label: 'Contact Us' }
];
